import React from 'react'
import { SlIcon } from '@shoelace-style/shoelace/dist/react'
import StyledNetworkItem from '../styles'

const Twitter: React.FC = () => (
  <StyledNetworkItem
    href="https://twitter.com/Nomiswap"
    target="_blank"
    rel="noreferrer noopener"
    className="text-brand-twitter"
  >
    <SlIcon library="social" name="twitter" />
  </StyledNetworkItem>
)

export default Twitter
